<script lang="ts">
export let data: any[] = [];

type FilterType = "regex" | "lt" | "gt" | "custom";

interface Filter {
	type:  FilterType;
	key:   string;
	value: any;
}

let filters = new Map<HTMLElement, Filter>();

function filter (data: any[], filters: Map<HTMLElement, Filter>) {
	const output: any[] = [];

	data.forEach((row: any) => {
		let valid = true;

		for (let [key, filter] of filters) {
			let val = row[filter.key];

			switch (filter.type) {
				case "regex":
					if (!filter.value.test(val)) {
						valid = false;
					}
					break;
				case "lt":
					console.log(+val, filter.value);
					valid = +val < filter.value;
					break;
			}

			if (!valid) {
				break;
			}
		}

		if (valid) {
			output.push(row);
		}
	})

	return output;
}

$: filtered = filter(data, filters);

export function regex (e: Event, key: string) {
	const target = e.target as HTMLInputElement;
	const value  = target.value;

	if (!value) {
		filters.delete(target);
		filters = filters;
		return;
	}

	filters = filters.set(target, {
		type:  "regex",
		value: new RegExp(value, "i"),
		key,
	});
}

export function lt (e: Event, key: string) {
	const target = e.target as HTMLInputElement;
	const value  = target.value;

	if (!value) {
		filters.delete(target);
		filters = filters;
		return;
	}

	filters = filters.set(target, {
		type:  "lt",
		value: +value,
		key,
	});
}
</script>

<slot name="search" {regex} {lt}>

</slot>

<slot {filtered}></slot>
